import { AppConstants } from "../../../../core/constants/constants";
import { MessageParams } from "../../domain/entities/addMessageSocket";
import { ChatMessage } from "../../domain/entities/getMessages";
import { NewMessageResponse } from "../../domain/entities/onNewMessageSocket";
import { UpdatedMessageResponse } from "../../domain/entities/onUpdatedMessageSocket";
import { UpdateChatStatusSocket } from "../../domain/entities/UpdateChatStatusSocket";
import { UpdatedChatStatusSocket } from "../../domain/entities/UpdatedChatStatusSocket";
import { MessageReadParams } from "../../domain/entities/updateMessageReadSocket";
import { ChatSocketRepository } from "../../domain/repositories/ChatSocketRepository";
import { ChatSocketDataSource } from "../datasource/ChatSocketDataSource";

export class ChatRepositorySocketImpl implements ChatSocketRepository {
	constructor(private dataSource: ChatSocketDataSource) {}

	connectSocket(): Promise<void> {
		return AppConstants.getRightOrLeftSide<void>(
			this.dataSource.connectSocket()
		);
	}

	disconnectSocket(): Promise<void> {
		return AppConstants.getRightOrLeftSide<void>(
			this.dataSource.disconnectSocket()
		);
	}

	addMessage(messageParams: MessageParams): Promise<void> {
		return AppConstants.getRightOrLeftSide<void>(
			this.dataSource.addMessage(messageParams)
		);
	}

	updateMessageRead(params: MessageReadParams): Promise<void> {
		return AppConstants.getRightOrLeftSide<void>(
			this.dataSource.updateMessageRead(params)
		);
	}

	emitTempMessage(messageId: string): Promise<void> {
		return AppConstants.getRightOrLeftSide<void>(
			this.dataSource.emitTempMessage(messageId)
		);
	}

	onNewMessage(callback: (data: NewMessageResponse) => void): void {
		this.dataSource.onNewMessage(callback);
	}

	onUpdateMessage(callback: (data: UpdatedMessageResponse[]) => void): void {
		this.dataSource.onUpdateMessage(callback);
	}

	onTempMessageSeen(
		callback: (data: ChatMessage) => void
	): void {
		this.dataSource.onTempMessageSeen(callback);
	}

	updateChatStatus(data: UpdateChatStatusSocket): Promise<void> {
		return AppConstants.getRightOrLeftSide<void>(
			this.dataSource.updateChatStatus(data)
		);
	}
	onUpdatedChatStatus(callback: (data: UpdatedChatStatusSocket) => void): void {
		this.dataSource.onUpdatedChatStatus(callback);
	}
}
